// extracted by mini-css-extract-plugin
export default {"container":"HuntsDetailsSecurity_container__wBxUi","main-rule":"HuntsDetailsSecurity_main-rule__U18i8"};